export default __webpack_public_path__ + "static/media/job_offer8_l.32dfe740.jpg";